import { anchorElementType } from "./AnchorElement.js";
const anchorToolbarButton = {
  elementType: anchorElementType,
  label: "Link",
  title: "Link",
  blueprintIcon: "link"
};
export {
  anchorToolbarButton
};
//# sourceMappingURL=anchorToolbarButton.js.map
